import {Component, ChangeDetectionStrategy, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [MatButtonModule]
})
export class PageNotFoundComponent {

  constructor( private _router: Router ) { }

  reloadApp() {
    this._router.navigate(['/']);
  }
}
